import React from "react";

const Help = () => {
  return (
    <div className="d-flex justify-content-center align-items-center fs-1 fw-bold">
      Help
    </div>
  );
};

export default Help;
